import { shared, styled } from 'style'

export const StyledContainer = styled('div', {
  position: 'relative',
  width: '100%',
})

export const StyledTrigger = styled('button', {
  width: '$full',
  minWidth: 120,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'space-between',

  color: '$text1',
  fontWeight: '$medium',
  bgc: '$bg2',
  border: '1px solid $bg3',
  borderRadius: '$lg',

  spaceX: 2,

  '&:disabled': {
    pointerEvents: 'none',
    color: '$text3',
    bgc: '$transparent',
  },

  '&:hover': { borderColor: '$text2' },
  '&:focus': { outline: 'none', borderColor: '$text4' },

  '> span': {
    overflowX: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  variants: {
    size: {
      sm: {
        padding: '$1-5',
        fontSize: '$sm',
        lineHeight: '$sm',
      },
      md: {
        padding: '$2-5',
        fontSize: '$sm',
        lineHeight: '$sm',
      },
    },
    placeholder: {
      true: {
        color: '$text4',
        bgc: '$bg2',
      },
      false: {},
    },
  },

  defaultVariants: {
    size: 'md',
  },
})

export const StyledItem = styled('li', {
  ...shared.buttonReset,

  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  width: '$full',

  color: '$text1',
  fontWeight: '$medium',
  bgc: '$bg1',
  transition: '.25s',

  '&[disabled]': { pointerEvents: 'none', color: '$text3' },
  '&:hover': { bgc: '$bg2' },
  '&:focus': { outline: 'none', bgc: '$bg2' },

  '> span': {
    overflowX: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  variants: {
    focused: {
      true: { bgc: '$bg2' },
      false: {},
    },
    disabled: {
      true: {},
    },
  },
})

export const StyledContent = styled('ul', {
  ...shared.buttonReset,
  ...shared.scrollBars({}),

  zIndex: 1,
  maxHeight: '14rem',
  overflow: 'auto',
  border: '1px solid $transparent',
  borderRadius: '$lg',

  variants: {
    open: {
      true: {
        bgc: '$bg1',
        borderColor: '$bg3',
      },
      false: {
        height: 0,
      },
    },
    size: {
      sm: {
        [`& ${StyledItem}`]: {
          padding: '$2',
          pl: '$6',
          fontSize: '$sm',
          lineHeight: '$sm',
          borderRadius: '$lg',
        },
      },
      md: {
        [`& ${StyledItem}`]: {
          padding: '$3',
          pl: '$6',
          fontSize: '$sm',
          lineHeight: '$sm',
        },
      },
    },
  },

  defaultVariants: {
    size: 'md',
  },
})

export const StyledItemIndicator = styled('span', {
  position: 'absolute',
  left: 4,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
})
